import p5 from 'p5';
import femaleHeadModel from './11091_FemaleHead_v4.obj';
import headImg from './head.png'

let head;
var img;
let gfx;
let t;
let b;
let curs;
let red;
let blue;
let light;

const maxXChange = 125;
const maxYChange = 5;
const yNoiseChange = 0.01;
const timeNoiseChange = 0.013;

var inverted = false;


const sketch = (s) => {

    s.preload = () => {
        head = s.loadModel(femaleHeadModel, true);
        img = s.loadImage(headImg)
    };

    s.setup = () => {
        const c = s.createCanvas(
            s.windowWidth, s.windowHeight, s.WEBGL
        );
        c.style('display', 'block');
        c.parent('canvas1');
        s.smooth();


        b = s.createGraphics(270, 270);

        gfx = s.createGraphics(s.constrain(img.width - maxXChange * 2, 200, s.windowWidth), s.constrain(img.height - maxYChange * 2, 200, s.windowHeight));

        img.filter(s.GRAY)
        gfx.blendMode(s.DODGE);
        gfx.image(img, -maxXChange, -maxYChange);

        gfx.background(255);

        t = s.createGraphics(1000, 1000);

        t.noStroke();
        t.fill(0, 0, 0, 255)
        t.textAlign(s.LEFT, s.CENTER);
        t.textSize(46);
        t.text(`And one day soon, I'll see you again...`, 0, 500);


        curs = s.createGraphics(200, 200, s.WEBGL);
        curs.circle(50, 50);
    };

    s.windowResized = () => {
        s.resizeCanvas(s.windowWidth, s.windowHeight);
    };


    s.draw = () => {
        let dirY = (s.mouseY / s.height - 0.5) * 2;
        let dirX = (s.mouseX / s.width - 0.5) * 2;

        red = s.color(255, 0, 0);
        blue = s.color(0, 0, 255)

        s.push();
        s.background(0);

        light = s.directionalLight(red, dirX, dirY, 0.25);
        s.stroke(225, 255, 255, 10);
        s.strokeWeight(0.09);
        s.rotateY(s.frameCount * 0.01 / s.PI);
        s.rotateX(s.frameCount * 0.02 / s.PI);
        s.model(head);
        s.noErase();
        s.pop();


        // s.push();
        // s.translate(0, -200, 100);
        // if (s.mouseIsPressed) {
        //     s.scale(s.random(0.1, 1))
        //     for (let i = 0; i < img.height / 60; i++) {
        //         drawStreak()
        //     }
        // }
        // s.pop();

        s.push();
        s.noErase()
        s.translate(0, 0);
        b.background(0, 0, 0, 0);
        s.image(b, -135, -135);
        s.pop();

        s.push();
        s.noStroke();
        t.noStroke();
        s.translate(0, 0,0);
        s.rotateY(s.frameCount * -0.0075);
        s.rotateZ(25);
        s.texture(t);
        s.sphere(135);

        s.pop();

        s.push();
        s.noCursor();
        s.translate(-10, -10, 200)
        s.fill(255);
        s.image(curs, s.mouseX - s.width / 2, s.mouseY - s.height / 2, 100, 100)

        s.pop();



    };

    function drawStreak() {
        let y = gfx.floor(gfx.random(gfx.height));
        let h = gfx.floor(gfx.random(20, 30));
        let xChange = gfx.floor(gfx.map(gfx.noise(y * yNoiseChange, (s.mouseY * 0.3 + s.frameCount) * timeNoiseChange), 0.06, 0.94, -maxXChange, maxXChange));
        let yChange = gfx.floor(xChange * (maxYChange / maxXChange) * gfx.random() > 0.1 ? -1 : 1);

        if (gfx.random() < gfx.dist(s.pmouseX, s.pmouseY, s.mouseX, s.mouseY) / gfx.width * 0.3 + 0.0015) gfx.filter(gfx.POSTERIZE, gfx.floor(gfx.random(2, 6)));
        if (gfx.mouseIsPressed && gfx.abs(gfx.mouseY - y) < 60) {
            if (!inverted) gfx.filter(gfx.INVERT);
            inverted = true;
        } else {
            if (inverted) gfx.filter(gfx.INVERT);
            inverted = false
        }

        s.image(img, xChange - maxXChange, -maxYChange + y + yChange, img.width, h, 0, y, img.width, h);
    }


};



const sketchInstance1 = new p5(sketch);
